import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const claimExcessApiService = {
    addManExcessCalcGadget,
    addManExcessCalcClaim,
    getExcessPayments,
    updateExcessPaymentStatus
}

function addManExcessCalcGadget(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claimexcess/addmanualgadgetexcesscalc', payload)
}

function addManExcessCalcClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claimexcess/addmanualclaimexcesscalc', payload)
}

function getExcessPayments(payload) {
    return axios.post(baseUrl + '/api/admin/v1/payment/getexcesspayments', payload)
}

function updateExcessPaymentStatus(payload) {
    return axios.post(baseUrl + '/api/admin/v1/payment/updatecardpaymentstatus', payload)
}